import {
  PrimaryButton as PrimaryButtonStyled,
  SecondaryButton as SecondaryButtonStyled,
} from "./styles";

// Cast to fix React 17 + @types/react 18 compatibility issue
const PrimaryButton = PrimaryButtonStyled as any;
const SecondaryButton = SecondaryButtonStyled as any;

type Props = {
  title?: any;
  url?: any;
  index?: number;
};

/** @deprecated */
const ExternalLink: React.FC<Props> = (props) => {
  const { url, title, index } = props;

  if (typeof url !== "string") return null;
  if (typeof title !== "string") return null;

  if (index && index > 0) {
    return <SecondaryButton href={url}>{title}</SecondaryButton>;
  }
  return <PrimaryButton href={url}>{title}</PrimaryButton>;
};

export default ExternalLink;
